export default "__VITE_ASSET__DmDYCHQD__"